var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_vm._v("\n    Logout 한글\n  ")])])
}]

export { render, staticRenderFns }